import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import { Spinner } from '../../components'

export class Span extends React.PureComponent {
  static propTypes = {
    forField: PropTypes.string.isRequired,
    searchKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    loadingComponent: PropTypes.element,
    className: PropTypes.string
  }

  static defaultProps = {
    loadingComponent: <Spinner type='brand' size='x-small' />
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data.error && !state.refetch) {
      return { refetch: true }
    } else if (state.refetch) {
      return { refetch: false }
    } else {
      return null
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.refetch && this.state.refetch) {
      this.props.data.refetch()
    }
  }

  state = {
    refetch: false
  }

  getValue(optionsData, searchKey) {
    if (searchKey === null)
      return ''

    let value = ''

    optionsData.map((option,i) => {
      if(searchKey.toLowerCase() === option.name.toLowerCase()) {
        value = option.description;
      }
      return null
    })

    return value
  }

  render() {
    if (this.props.data.loading) {
      return this.props.loadingComponent
    }

    if (this.props.data.error) {
      return (
        <div>
          Failed to read value.
        </div>
      )
    }

    let value = this.getValue(
      this.props.data.__type.enumValues,
      this.props.searchKey
    )

    return (
      <span className={this.props.className}>
        {this.props.label &&
          <div>
            {this.props.label}
          </div>
        }
        {value}
      </span>
    )
  }
}

const getOptions = gql`
  query($name: String!) {
    __type(name: $name) {
      name
      kind
      enumValues {
        name
        description
      }
    }
  }
`

const withData =
  graphql(getOptions, {
    options: ({ forField, searchKey }) => ({
      variables: {
        name: forField
      },
      searchKey: searchKey
    })
  })

export default withData(Span)



// WEBPACK FOOTER //
// ./src/components/span/index.js